import React from 'react'

import MetabaseEmbed from '@aletheia/common/components/MetabaseEmbed'

export const StatisticsDonationsByFund: React.FC = () => {
  return (
    <>
      <MetabaseEmbed
        embedType="chart"
        title={'Donations to the Global Health and Development Fund'}
        src="https://dashboard.effectivealtruism.org/public/question/10f6cda9-1aa6-4306-bdcd-93bded8de3cd"
      />
      <MetabaseEmbed
        embedType="chart"
        title={'Donations to the Animal Welfare Fund'}
        src="https://dashboard.effectivealtruism.org/public/question/e3f58807-e035-4f0c-a623-e34cb4fac2c3"
      />
      <MetabaseEmbed
        embedType="chart"
        title={'Donations to the Long-Term Future Fund'}
        src="https://dashboard.effectivealtruism.org/public/question/4cbbbf6a-26df-44ad-bb3a-768716825be9"
      />
      <MetabaseEmbed
        embedType="chart"
        title={'Donations to the EA Infrastructure Fund'}
        src="https://dashboard.effectivealtruism.org/public/question/50b26028-a0e5-4e05-a1ce-a746e326e5d7"
      />
    </>
  )
}

export default StatisticsDonationsByFund
